// Problem messages of the console pages without a catalog of their own: the
// desk (Today, the calendar, the booking drawer, walk-ins), the insights pages
// (dashboard, finance, reports, site content), WhatsApp messages and the
// invite page. Registered once at start by apps/console/src/app/problems.ts.
import type { ProblemTexts } from '../errors';

export const consoleProblems: ProblemTexts = {
  'car_unavailable.busy': {
    ar: 'السيارة محجوزة في هذا الموعد، أو لن تعود وتجهز قبله',
    en: "The car is booked at this time, or won't be back and ready before it",
  },
  'car_unavailable.not_returned': {
    ar: 'السيارة ما زالت مع زبون بعد موعد عودتها. اختر سيارة أخرى.',
    en: 'The car is still out past its return time. Choose another car.',
  },
  'car_unavailable.out_of_service': { ar: 'السيارة خارج الخدمة', en: 'The car is out of service' },
  no_change: { ar: 'لم يتغير الموعد ولا السيارة', en: 'Neither the time nor the car changed' },
  hold_not_due: {
    ar: 'لم تنتهِ مهلة الدفع لهذا الحجز بعد',
    en: "This booking's payment time hasn't run out yet",
  },
  payments_unavailable: {
    ar: 'تسجيل الدفع عند المكتب غير متاح بعد. حصّل المبلغ عند التسليم.',
    en: "Desk payments can't be recorded yet. Take the payment at the handover.",
  },
  weather_unavailable: { ar: 'حالة الطقس غير متاحة الآن', en: 'The weather is not available right now' },
  weather_location_invalid: { ar: 'موقع الطقس غير صحيح', en: 'The weather location is not valid' },
  notification_not_found: { ar: 'لم نجد هذه الرسالة', en: "We couldn't find this message" },
  notification_not_failed: {
    ar: 'تُعاد محاولة الرسائل التي فشلت فقط',
    en: 'Only failed messages can be sent again',
  },
  notification_disabled: {
    ar: 'هذه الرسالة موقوفة في إعدادات الإشعارات',
    en: 'This message is switched off in the notification settings',
  },
  notification_status_invalid: { ar: 'حالة الرسالة غير معروفة', en: 'Unknown message status' },
  notification_template_invalid: { ar: 'نوع الرسالة غير معروف', en: 'Unknown message type' },
  dashboard_ids_invalid: {
    ar: 'تعذّر تحميل اللوحة. حدّث الصفحة.',
    en: "The dashboard couldn't be loaded. Refresh the page.",
  },
  dashboard_layout_invalid: { ar: 'تعذّر حفظ ترتيب اللوحة', en: "The dashboard layout couldn't be saved" },
  dashboard_period_invalid: { ar: 'الفترة غير صحيحة', en: 'The period is not valid' },
  dashboard_widget_failed: { ar: 'تعذّر تحميل هذه البطاقة', en: "This card couldn't be loaded" },
  dashboard_widget_not_found: { ar: 'هذه البطاقة غير موجودة', en: 'This card does not exist' },
  finance_filter_invalid: { ar: 'عوامل التصفية غير صحيحة', en: 'The filters are not valid' },
  report_range_invalid: { ar: 'نطاق التاريخ غير صحيح', en: 'The date range is not valid' },
  report_type_invalid: { ar: 'نوع التقرير غير معروف', en: 'Unknown report type' },
  export_invalid: { ar: 'طلب التصدير غير صحيح', en: 'The export request is not valid' },
  export_not_found: { ar: 'لم نجد ملف التصدير', en: "We couldn't find this export" },
  export_not_ready: {
    ar: 'ملف التصدير قيد التجهيز. حاول بعد لحظات.',
    en: 'The export is being prepared. Try again in a moment.',
  },
  export_failed: { ar: 'تعذّر التصدير. صدّر مجدداً.', en: 'The export failed. Export again.' },
  export_expired: {
    ar: 'انتهت صلاحية ملف التصدير. صدّر مجدداً.',
    en: 'The export file has expired. Export again.',
  },
  export_too_large: {
    ar: 'التقرير أكبر من أن يُصدَّر. ضيّق نطاق التاريخ.',
    en: 'The report is too large to export. Narrow the date range.',
  },
  expense_invalid: { ar: 'بيانات المصروف غير صحيحة', en: 'The expense details are not valid' },
  expense_not_found: { ar: 'لم نجد هذا المصروف', en: "We couldn't find this expense" },
  expense_voided: {
    ar: 'أُلغي هذا المصروف ولا يمكن تعديله',
    en: 'This expense was voided and can no longer change',
  },
  void_reason_required: { ar: 'اكتب سبب الإلغاء', en: 'Write the reason for voiding' },
  content_key_not_found: { ar: 'لم نجد هذا النص', en: "We couldn't find this text" },
  content_section_not_found: { ar: 'لم نجد هذا القسم', en: "We couldn't find this section" },
  content_section_not_toggleable: { ar: 'هذا القسم يظهر دائماً', en: 'This section is always shown' },
  content_revision_not_found: { ar: 'لم نجد هذه النسخة', en: "We couldn't find this version" },
  content_locale_invalid: { ar: 'اللغة لا تناسب هذا النص', en: "The language doesn't fit this text" },
  content_value_invalid: { ar: 'النص غير صالح لهذا الحقل', en: 'The text is not valid for this field' },
  password_invalid: { ar: 'كلمة المرور غير صالحة', en: 'The password is not valid' },
  password_mismatch: { ar: 'كلمتا المرور غير متطابقتين', en: "The passwords don't match" },
  password_policy: {
    ar: 'كلمة المرور لا تحقق الشروط المطلوبة',
    en: "The password doesn't meet the requirements",
  },
  auth_not_configured: {
    ar: 'تسجيل الدخول غير مهيّأ على هذا الخادم',
    en: 'Sign-in is not set up on this server',
  },
};
